import * as Types from './api/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { ButtonFragmentDoc } from './button';
export type PromptsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type PromptsQuery = {
  prompts: Array<{
    __typename: 'Prompt';
    id: string;
    colorTheme: Types.ColorTheme;
    layout: {
      __typename: 'DefaultLayout';
      imageUrl: string | null;
      logoUrl: string | null;
      title: string | null;
      subTitle: string | null;
      text: string | null;
      helpInfo: string | null;
      closeButton: {
        __typename: 'Action';
        tracking: {
          __typename: 'Tracking';
          details: Types.Scalars['Map']['output'];
          identifier: string;
        };
        clientAction:
          | { __typename: 'CloseClientAction' }
          | { __typename: 'GoToClientAction'; destination: string }
          | { __typename: 'IgnoreClientAction' }
          | { __typename: 'LogoutClientAction' };
        serverAction: { __typename: 'ServerAction'; mutationPayload: string } | null;
      } | null;
      extendedInfo: {
        __typename: 'ExtendedInfo';
        linkText: string;
        title: string;
        text: string;
        impressionTracking: {
          __typename: 'Tracking';
          details: Types.Scalars['Map']['output'];
          identifier: string;
        };
      } | null;
      buttons: Array<{
        __typename: 'ActionButton';
        textColor: string | null;
        backgroundColor: string | null;
        backgroundOpacityInPct: number | null;
        focusedTextColor: string | null;
        focusedBackgroundColor: string | null;
        focusedBackgroundOpacityInPct: number | null;
        outlineColor: string | null;
        text: string;
        color: Types.ButtonColor;
        action: {
          __typename: 'Action';
          tracking: {
            __typename: 'Tracking';
            details: Types.Scalars['Map']['output'];
            identifier: string;
          };
          clientAction:
            | { __typename: 'CloseClientAction' }
            | { __typename: 'GoToClientAction'; destination: string }
            | { __typename: 'IgnoreClientAction' }
            | { __typename: 'LogoutClientAction' };
          serverAction: { __typename: 'ServerAction'; mutationPayload: string } | null;
        };
      }>;
    };
    blurAction: {
      __typename: 'Action';
      tracking: {
        __typename: 'Tracking';
        details: Types.Scalars['Map']['output'];
        identifier: string;
      };
      clientAction:
        | { __typename: 'CloseClientAction' }
        | { __typename: 'GoToClientAction'; destination: string }
        | { __typename: 'IgnoreClientAction' }
        | { __typename: 'LogoutClientAction' };
      serverAction: { __typename: 'ServerAction'; mutationPayload: string } | null;
    } | null;
    impressionTracking: {
      __typename: 'Tracking';
      details: Types.Scalars['Map']['output'];
      identifier: string;
    };
  }>;
};

export const PromptsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Prompts' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prompts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'path' },
                value: { kind: 'StringValue', value: '/', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'layout' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'DefaultLayout' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'subTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'helpInfo' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'closeButton' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tracking' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'details' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'identifier' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'clientAction' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: '__typename' },
                                        },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: { kind: 'Name', value: 'GoToClientAction' },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'destination' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'serverAction' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'mutationPayload' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'extendedInfo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'impressionTracking' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'details' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'identifier' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'buttons' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'Button' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'colorTheme' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'blurAction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tracking' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'details' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'clientAction' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'GoToClientAction' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'destination' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'serverAction' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'mutationPayload' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'impressionTracking' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'details' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...ButtonFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<PromptsQuery, PromptsQueryVariables>;
